/**
 * Different settings how to display an Alert.
 */
export enum AlertDisplay {
  /** Never displayed */
  NONE,

  /** Disappears automatically after a certain amount of time */
  TEMPORARY,

  /** Remains visible until the user interacts with the element */
  PERSISTENT,
}
